// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tKcN","question":"styles_question__3A7I4","inputVisibleButton":"styles_inputVisibleButton__xm6DK","note":"styles_note__1tQ71"};